import { useState } from 'react';
import type { Locale } from '@/i18n/localeCodes';
import type { SceneInvestigation } from '../scene-investigation.types';
import { SceneSnapshotImage } from './scene-snapshot-image';
export function SceneInvestigationDisclosure({ result, locale, timestamp }: {
    result: SceneInvestigation;
    locale: Locale;
    timestamp: string;
}) {
    const [open, setOpen] = useState(false);
    return <details className="ah-adventure-details" data-scene-investigation="true" onToggle={event => {
            const current = event.currentTarget;
            if (current.open)
                for (const other of current.closest('.th-adventure-list')?.querySelectorAll<HTMLDetailsElement>('details[data-scene-investigation]') ?? [])
                    if (other !== current && other.open) {
                        other.open = false;
                        other.dispatchEvent(new Event('toggle'));
                    }
            setOpen(current.open);
        }}>
  <summary style={{ cursor: 'pointer', padding: '7px 0', minHeight: 24 }}><span style={{ opacity: .6 }}>[{timestamp}] </span><span style={{ display: '-webkit-box', WebkitLineClamp: open ? undefined : 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{result.thought.text[locale]}</span></summary>
  {open && <div style={{ padding: '4px 0 12px' }}>
   <SceneSnapshotImage snapshot={result.snapshot} locale={locale}/>
   {result.effect.applied && result.effect.kind !== 'none' && <p>{result.effect.text[locale]}</p>}
  </div>}
 </details>;
}
